import { Link } from 'react-router-dom';
import Eyebrow from '../components/Eyebrow';
import ForceLight from '../components/ForceLight';
import Wordmark from '../components/Wordmark';

export default function NotFoundPage() {
  return (
    <ForceLight>
      <main className="shell shell-centred">
        <div className="not-found rise">
          <Wordmark />
          <Eyebrow accent>Page not found</Eyebrow>
          <h1 className="title-xl">That page is not here</h1>
          <Link className="btn btn-outline" to="/">Return home</Link>
        </div>
      </main>
    </ForceLight>
  );
}
